<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <base-page-layout title="Notificações">
      <v-container fluid grid-list-md class="pa-0">
        <mf-card-container
          title="Notificações de ofertas de trade"
          description="Aqui você pode configurar se deseja receber notificações de lembrete sobre a disponibilidade de novas ofertas de trade."
        >
          <v-container class="px-0 pt-0" fluid>
            <v-row>
              <v-col cols="3">
                <v-checkbox
                  v-model="notifications.availableIndustryCampaigns.whatsappBusinessAPI"
                  :disabled="!allowIndustryCampaignNotifications"
                  label="Whatsapp"
                  color="primary"
                  class="pt-0"
                  hide-details
                  single-line
                />
              </v-col>
              <v-col cols="3">
                <v-checkbox
                  v-model="notifications.availableIndustryCampaigns.email"
                  :disabled="!allowIndustryCampaignNotifications"
                  label="Email"
                  color="primary"
                  class="pt-0"
                  hide-details
                  single-line
                />
              </v-col>
            </v-row>
            <mf-info-card
              v-if="!allowIndustryCampaignNotifications"
              variant="warning"
              description="Seu usuário não possui permissão para acessar o módulo de ofertas de trade. Por esse motivo, não é possível receber notificações relacionadas a este módulo."
            />
          </v-container>
          <mf-action-buttons
            :primary-button="{
              text: 'Salvar',
              action: save,
              isVisible: true,
              isDisabled: !allowIndustryCampaignNotifications,
              isLoading: loading,
            }"
          />
        </mf-card-container>
      </v-container>
    </base-page-layout>
  </mf-loading-dialog>
</template>
<script>
import { QUERY_GET_USER, MUTATION_UPDATE_SELF_NOTIFICATION_CONFIGURATIONS } from '../../graphql'

export default {
  name: 'Profile',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
  },
  data: () => ({
    notifications: {
      availableIndustryCampaigns: {
        whatsappBusinessAPI: false,
        email: false,
      },
    },
    loading: false,
  }),
  computed: {
    allowIndustryCampaignNotifications() {
      return this.$permissions.havePagePermission('industria/ofertas_trade') && this.$getAllowedModules()['industry']
    },
  },
  apollo: {
    me: {
      query: QUERY_GET_USER,
      variables() {
        return {
          email: this.$getLoggedUser().username,
        }
      },
      update({ getPlatformUser }) {
        this.notifications.availableIndustryCampaigns.whatsappBusinessAPI =
          getPlatformUser.notificationConfigurations?.availableIndustryCampaigns?.whatsappBusinessAPI ?? false
        this.notifications.availableIndustryCampaigns.email = getPlatformUser.notificationConfigurations?.availableIndustryCampaigns?.email ?? false
      },
    },
  },
  methods: {
    async save() {
      this.loading = true
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_UPDATE_SELF_NOTIFICATION_CONFIGURATIONS,
          variables: {
            notificationConfigurations: this.notifications,
          },
        })
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao editar o perfil.', snackbarColor: 'error' })
      }

      this.loading = false
    },
  },
}
</script>
